import styled from 'styled-components';

export const Label = styled.label`
    font-family: 'Poppins', sans-serif;
    font-size: ${({ fontSize }) => fontSize};
    line-height: ${({ lineHeight }) => lineHeight};
    color: ${({ color }) => color};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    font-weight: ${({ fontWeight }) => fontWeight};
    ${({ theme }) => theme === 'light' && `
        display: flex;
    `}
`;
